var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{staticStyle:{"padding-top":"128px"},attrs:{"status":"403","title":"403","sub-title":"抱歉，您无权限访问"}})
}
var staticRenderFns = []

export { render, staticRenderFns }